<div
  *ngIf="
    ipBoard?.boardPart?.placementType?.ordinal === ON_POSTS?.ordinal ||
    ipBoard?.boardPart?.placementType?.ordinal === ON_STONES?.ordinal
  "
>
  <mat-checkbox
    [(ngModel)]="ipBoardPlacement.extraHeight"
    (ngModelChange)="extraHeightChanged()"
    >Het bord 3 meter hoog i.p.v. 2 meter hoog plaatsen (bv. boven een haag)
    (+15 € op de plaatsing){{ multiple ? ' IP-bord #' + (index + 1) : '' }}
  </mat-checkbox>
</div>
